(function(konto) {
	konto.vp = {};
} (konto = window.konto));